export default "__VITE_ASSET__BcgafB2a__"